import Blazy from 'blazy'

const $ = window.jQuery
const $window = window.$window || $(window)

/**
 * Enables lazy loading on images & background images.
 *
 * By default the image in `src` or `backgroundImage` will be loaded,
 * then `data-blazy` will get loaded when "needed".
 */
const LazyLoading = {

    duration: 200,
    offset: 0,
    bLazy: false,
    config: {
        selector: '*[data-blazy]',
        src: 'data-blazy',
        container: 'window, .modal',    // listen to elements that scroll
        loadInvisible: true,
    },

    /**
     * Initialise functionality
     */
    init() {

        let vm = this

        // initialize blazy
        vm.bLazy = new Blazy(vm.config)

        // listen to new carousel slide images
        $('[data-slick]').on('afterChange', () => {
            vm.revalidate()
        })

        // listen to post form changes
        $(window).on('mwb/plugin/post_forms/added_posts', () => {
            vm.revalidate()
        })

        // periodically check when in admin for images to be lazy loaded
        if ($('.block-editor').length) {
            setInterval(() => {
                vm.revalidate()
            }, 5000)
        }

        // Listen to modal changes
        $(window).on('modal-change', () => {
            setTimeout(() => {
                vm.revalidate()
            }, 100)
        })

    },

    /**
     * Allow revalidating lazy loading from outside object
     */
    revalidate() {
        this.bLazy.revalidate()
    },

}

export default LazyLoading;